export default {
  setSidebarStatus(state, { sidebarOpen }) {
    Object.assign(state, { sidebarOpen });
  },
  setOnline(state, { online }) {
    Object.assign(state, { online });
  },
  setAuthenticated(state, { authenticated }) {
    Object.assign(state, { authenticated });
  },
  setProfileComplete(state, { profileComplete }) {
    Object.assign(state, { profileComplete });
  },
  setLoading(state, { loading }) {
    Object.assign(state, { loading });
  },
};
